import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CountrySelectionService } from './country-selection.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService) { }

  submitAppointment(data: any): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('appointment', country);
        return this.http.post(apiUrl, data);
      })
    );
  }

  getAppointmentCenters(): Observable<string[]> {
    // In a real application, this would fetch data from an API.
    // Here, we return a hardcoded list as an Observable.
    const centers = ['New York', 'London', 'Tokyo', 'Paris', 'Sydney'];
    return of(centers);
  }

  getAppointments(): Observable<any[]> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('appointments', country);
        return this.http.get<any[]>(apiUrl);
      })
    );
  }

  cancelAppointment(id: number): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl(`appointments/${id}`, country);
        return this.http.delete(apiUrl);
      })
    );
  }

  getAppointmentReminderContent(): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('get_appointment_reminder_content', country);
        return this.http.get<any[]>(apiUrl);
      })
    );
  }
}
